import { createService } from 'reservice'
import {
  CREATE_LOGIN_TOKEN,
  FETCH_BEST_SELLER_SOLD_OUT_COUNT,
  FETCH_BEST_SELLER_SOLD_OUT,
  FETCH_NEED_REVIEW_COUNT,
  FETCH_NEED_REVIEWS,
  UPDATE_COMMENTS,
  UPDATE_SALABLE_AMOUNT,
  FETCH_GD_ON_AND_OFF_BY_ID,
  UPDATE_GD_ON,
  UPDATE_GD_OFF,
  FETCH_PROBLEMS_COUNT,
  FETCH_PROBLEMS,
  FETCH_PROBLEM_DETAIL,
  UPDATE_ANSWERS
} from '../actionTypes'

// scm
export const createLoginToken = createService(CREATE_LOGIN_TOKEN)
export const fetchBestSellerSoldOutCount = createService(FETCH_BEST_SELLER_SOLD_OUT_COUNT)
export const fetchBestSellerSoldOut = createService(FETCH_BEST_SELLER_SOLD_OUT)
export const fetchNeedReviewCount = createService(FETCH_NEED_REVIEW_COUNT)
export const fetchNeedReviews = createService(FETCH_NEED_REVIEWS)
export const updateComments = createService(UPDATE_COMMENTS)
export const updateSalableAmount = createService(UPDATE_SALABLE_AMOUNT)
export const fetchGdOnAndOffById = createService(FETCH_GD_ON_AND_OFF_BY_ID)
export const updateGdOn = createService(UPDATE_GD_ON)
export const updateGdOff = createService(UPDATE_GD_OFF)
export const fetchProblemsCount = createService(FETCH_PROBLEMS_COUNT)
export const fetchProblems = createService(FETCH_PROBLEMS)
export const fetchProblemDetail = createService(FETCH_PROBLEM_DETAIL)
export const updateAnswers = createService(UPDATE_ANSWERS)
